module.exports = __webpack_public_path__ + "img/homebg.fc3029e7.png";